import React from "react";
import { AIChatPanel } from "@/components/AIChatPanel";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Assistant() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-6">
      <div className="fade-up">
        <p className="uppercase text-xs tracking-[0.2em] text-[#8A9992] mb-2">{t("assistant.kicker")}</p>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight text-[#0A110E] flex items-center gap-3">
          {t("assistant.title")}
          <Sparkles className="w-8 h-8 text-[#1C7C54]" />
        </h1>
        <p className="text-[#5F7368] mt-2">{t("assistant.subtitle", { defaultValue: "Pregúntale a tu asistente financiero — conoce tus datos." })}</p>
      </div>
      <AIChatPanel variant="page" />
    </div>
  );
}
